module.exports = __webpack_public_path__ + "static/media/ils_no_data_mob.b381a10d.svg";